export default __webpack_public_path__ + "static/media/five-seven.55badb9a.svg";